import { FormField, SwitchField } from "common";
import { useFormikContext } from "formik";
import React from "react";
import { CheckInValidationType } from "types";
import { ContentLayout } from "@/components/Layout/ContentLayout";
import { CheckInPreferenceFormValues } from "@/components/Product/ExperienceCheckIn/ExperienceCheckIn.types";
import { hasCountValidation } from "@/components/Product/ExperienceCheckIn/useMultiCheckInFieldValues";

export const CheckInConfigurationSection = () => {
    const { values, setFieldValue, touched } = useFormikContext<CheckInPreferenceFormValues>();

    const handleCheckInToggle = (value: boolean) => {
        if (value && !hasCountValidation(values.validations) && !touched.validations) {
            /** When seller enables check-in, we need to display multi-checkin disabled by default. So, add a "COUNT" validation with `max=1` */
            setFieldValue("validations", [{ object: CheckInValidationType.COUNT, max: 1 }]);
        }

        setFieldValue("enabled", value);
    };

    return (
        <ContentLayout.Section title="Check-In" description="Configure your guest check-in workflow">
            <div className="space-y-4">
                <FormField name="enabled" label="Require Check-In">
                    <SwitchField isChecked={values.enabled} onChange={handleCheckInToggle}>
                        Require guests to check-in to participate in the event
                    </SwitchField>
                </FormField>
            </div>
        </ContentLayout.Section>
    );
};
